import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=a272cb60&scoped=true&"
import script from "./ImportContacts.vue?vue&type=script&lang=js&"
export * from "./ImportContacts.vue?vue&type=script&lang=js&"
import style0 from "./ImportContacts.vue?vue&type=style&index=0&id=a272cb60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a272cb60",
  null
  
)

export default component.exports